
export default {
    areaAtuacao: {},
    areasAtuacoes: []
}